import { Component, OnInit,Inject } from '@angular/core';
import { CustomerService } from '../../GET_NEW_UI/services/customer.service';
import { CustomerContactService } from '../add-new-user-cl/customer-contact.service';

import { crsfNewVM, crsfVM, CustomerUserContacts, Jobsite_tab, JSLVM, UserOverviewModelCustomerContact } from '../Models/customer-contact.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-add-new-user-jsl',
  templateUrl: './add-new-user-jsl.component.html',
  styleUrls: ['./add-new-user-jsl.component.css']
})
export class AddNewUserJslComponent implements OnInit {
  array1:any = [];
  array2:any = [];
  
  selectedOptions1:any = [];
  selectedOptions2:any = [];
  
  JobsiteListForTab:crsfVM[];
  UserVList:any;
  selectedSiteId:string;
  selectedsiteName:string
  selectedUserId:number;
  customerId:number;
  jobsitebyCustomerID:crsfNewVM[]
  JobsiteList:crsfNewVM[];
  customerName

  jobsiteList:UserOverviewModelCustomerContact[]=[]
  customerList:UserOverviewModelCustomerContact[]=[]
  filtereduserforList:UserOverviewModelCustomerContact[]=[]
  

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private  _dialog:MatDialog,
    public dialogRef:MatDialogRef<AddNewUserJslComponent>,
    //private _JobsiteService:CrsfJobSiteService,
    private _userVService:CustomerContactService,
   private _contactService:CustomerContactService,
   private _customerService:CustomerService,
  
  ) { }

  ngOnInit() {
    this.GetJobSiteDetails();
   
    //this.AddNewJob();
    //this.PostUserToJOBSITEContact();
    //this.AddNewUsertoJobsite()  
    //this.AddContactsfromJS();
    //this.onChangeCustomer();
    
    this.customerId=this.data.customerId;
    this.customerName=this.data.customerName
    this.JobsiteListForTab=this.data.JobsiteListForTab
    this.GetuserDetails();
  }
  DialogClose(){
    this.dialogRef.close(false)

  }
  AddNew(){
    this.dialogRef.close(true)
  }
  GetAllUsersForUser(){
    if(this.customerId>0){
      this._contactService.GetAllUsersForUser().subscribe(res=>{
       // console.log("administration user accessd", res)
       this.jobsiteList= res.filter(x=>x.Access=="Jobsite")
      // this.customerList=res.filter(x=>x.Access=="Customer")
   
       // console.log(" this.jobsiteList",  this.jobsiteList)
       // console.log(" this.jobsiteList",  this.jobsiteList)
       // console.log(" this.customerName",  this.customerName)
       
      
      })
    }
    
  }



  GetJobSiteDetails(){
    
    this._customerService.getCrsfInfo_().subscribe(res=>{
      this.JobsiteList = res
  
     // console.log("this.customerauto",this.JobsiteList);
      this.jobsitebyCustomerID= this.JobsiteList.filter(x=>x.customer_auto == this.customerId);
     // console.log("this.jobsitebyCustomerID",this.jobsitebyCustomerID);
      

  });
  }
  
  GetuserDetails(){
    // if(this.customerId>0){
    //   this._customerService.filterUserInfoJS(this.).subscribe(res=>{
    //     console.log("Arra11",res)
        
        
    //     this.array1 = res;
      
    // })
    // }
 
}

jobsiteChanged(event:any) {
  let value = event.value;
  console.log("selectedSiteId", this.selectedSiteId)
  this._customerService.filterUserInfoJS(value).subscribe(res=>{
    console.log("Arra11",res)
    
    
    this.array1 = res;
  
})
  }
    AddContactsfromJS()
    {
     // console.log("s2",this.selectedOptions2);
     // console.log("s1",this.selectedOptions1);
     // console.log("addContact", this.array2);
      let params = new  CustomerUserContacts();
      params.customer_auto=Number(this.customerId);
      params.user_auto=this.selectedUserId;
      params.equipmentid_auto=0;
      params.EvalA=true;
      params.EvalB=true;
      params.EvalC=true;
      params.EvalX=true;
      params.eq_undercarriage=true;
      params.Type="SITE";

      this._contactService.AddContactsfromJS(params).subscribe(res=>{
       // console.log("Contact",res);
        
      })
     // console.log("this.selectedUserId",this.selectedUserId);
     
    }
  


AddUserInJS(user_auto:number,job_site:string)
{
  this._contactService.AddUserInJS(user_auto,job_site).subscribe(res=>{
   // console.log("result",res);
  })
  //console.log("this.selectedUserId",this.selectedUserId);
}



onChangeCustomer(option:crsfNewVM){
  let temparr=[]
  this.selectedsiteName= option.site_name
 // console.log("this.selectedCustomer_",this.selectedsiteName)
  if(this.customerId>0){
    this._contactService.GetAllUsersForSelectedJobSite(option.crsf_auto).subscribe(res=>{
     // console.log("administration user accessd", res)
     this.jobsiteList= res.filter(x=>x.Access=="Jobsite")
    
// console.log("selectedSiteId", this.selectedSiteId)
     // console.log(" this.jobsiteList",  this.jobsiteList)
      //console.log(" this.customerList",  this.jobsiteList)
     // console.log(" this.customerName",  this.customerName)
      let arr_ = [];
   this.jobsiteList.map(x=>{
     if(x.TeamName.length>0 && x.TeamName!=null){
      
       x.TeamName.map(y=>{
        if( y == this.selectedsiteName){
          arr_.push(x)
        }
       })
       
     }
   })
   this.filtereduserforList=arr_;
    //  this.filteredJobsiteforDropdown= this.jobsiteList.filter(x=>x.TeamName==)
     
     
     // console.log(" this.filtereduserforList",  this.filtereduserforList)
      this.array1 = this.filtereduserforList;
    
console.log("arr",this.array1)
console.log("JobsiteListForTabhhh",this.JobsiteListForTab)

      this.JobsiteListForTab.map(x=>{
        let checkhasexisitng = this.array1.find(z => z.UserId == x.user_auto && x.site_name.toLowerCase()== this.selectedsiteName.toLowerCase());
        if(checkhasexisitng)
        {
           temparr.push(checkhasexisitng)
          this.array2=temparr
          this.array1 = this.array1.filter(z=>z.UserId!=x.user_auto);
              
       console.log("arr2",this.array2)
        }
        else
        this.array2=temparr
        console.log("arr2__",this.array2)
      }) 
    
    })
  }
}

AddNewUsertoJobsite(){
  let useridarray:any[]=[];
  let cusidarray:any[]=[];
  if(this.array2.length>0)
  {
    this.array2.map(item =>{if(item.UserId){
      useridarray.push(item.UserId)
    }}
    )

  }
  //console.log("array2", this.array2)
 // console.log("add", this.selectedUserId)
    let params = new  JSLVM();
    params.customer_auto=this.customerId;
    params.user_auto=useridarray;
    params.EvalA=true;
    params.EvalB=true;
    params.EvalC=true;
    params.EvalX=true;
    params.crsf_auto=Number(this.selectedSiteId);
    params.Type='SITE';
    

   // console.log("this.params",params);
    this._customerService.AddNewUsertoJobsite_(params).subscribe(res=>{
     // console.log("result",res);
      if(res==true)
      {
        this.DialogClose();
      }
    })
   // console.log("this.selectedUserId",this.customerId);
    //console.log("this.selectedSiteID",this.selectedSiteId)
    
}

AddItem() {
  if (this.selectedOptions1.length > 0) {
    this.selectedOptions1.map(x=> {
      if (this.array2.length > 0) {
        let checkhasexisitng = this.array2.find(z => z.UserId == x.UserId);
        if (!checkhasexisitng) {
          this.array2.push(x);
          this.array1 = this.array1.filter(z=>z.UserId!=x.UserId);
          console.log("this.array1____",this.array1)
          // var remveiten=this.array1.find(w=>w.UserID==x.UserId)
          // console.log("ttt",remveiten)
          // if(remveiten){
          //   this.array1.pop(remveiten.UserID)
          // }
       
         
        }
      } else {
        this.array2.push(x);
        this.array1 = this.array1.filter(z=>z.UserId!=x.UserId);
        //this.array1.pop(x)
      }
    });
  }
  
}
RemoveItem() {
  if (this.selectedOptions2.length > 0) {
    this.selectedOptions2.map(x => {
      this.array2 = this.array2.filter(z => z.UserId != x.UserId);
      this.array1.push(x);
      this.selectedOptions2 = [];
    });
  }
}

}
